import React from 'react';
import classNames from 'classnames';
import { Modal } from 'reactstrap';
import PropTypes from 'prop-types';
import { ThemeProps } from '../../../../../shared/prop-types/ReducerProps';
import EventEditModalForm from './EventEditModalForm';

const EventEditModal = ({
  currentEditRow, changeShowEditModal, showEditModal, theme, selectedData, activeDayOptions, setForceRefresh, budgetGroupOptions, setShowEditModal,
}) => {
  const modalClasses = classNames({
    'todo__add-modal': true,
  }, theme.className, 'ltr-support');

  return (
    <Modal
      isOpen={showEditModal}
      toggle={changeShowEditModal}
      className={modalClasses}
    >
      <EventEditModalForm
        changeShowEditModal={changeShowEditModal}
        selectedData={selectedData}
        currentEditRow={currentEditRow}
        activeDayOptions={activeDayOptions}
        setForceRefresh={setForceRefresh}
        budgetGroupOptions={budgetGroupOptions}
        setShowEditModal={setShowEditModal}
      />
    </Modal>
  );
};

EventEditModal.propTypes = {
  changeShowEditModal: PropTypes.func.isRequired,
  showEditModal: PropTypes.bool.isRequired,
  theme: ThemeProps.isRequired,
};


export default EventEditModal;
